var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.$emit("submit", _vm.si)
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [_vm._v(" Edit ")]),
      _c(
        "section",
        { staticClass: "modal-card-body", staticStyle: { height: "510px" } },
        [
          _c(
            "b-field",
            { attrs: { label: "Comment 1", "label-position": "on-border" } },
            [
              _c("b-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.si.comment1,
                  callback: function ($$v) {
                    _vm.$set(_vm.si, "comment1", $$v)
                  },
                  expression: "si.comment1",
                },
              }),
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { label: "Comment 2", "label-position": "on-border" } },
            [
              _c("b-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.si.comment2,
                  callback: function ($$v) {
                    _vm.$set(_vm.si, "comment2", $$v)
                  },
                  expression: "si.comment2",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  "icon-left": "save",
                  type: "is-primary",
                  "native-type": "submit",
                },
              },
              [_vm._v(" Save ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }